import { faIdCard } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a id card icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/id-card?f=classic&s=solid
 */
export const IdCardIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faIdCard} {...props} />;
};
